import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 flex items-center justify-center bg-background-50">
        <div className="relative flex flex-col items-center justify-center text-center px-4 py-20">
          <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-background-100 select-none pointer-events-none z-0">
            404
          </h1>
          <div className="relative z-10">
            <div className="w-20 h-20 mx-auto mb-6 bg-accent-100 rounded-full flex items-center justify-center">
              <i className="ri-emotion-sad-line text-3xl text-accent-600"></i>
            </div>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">页面未找到</h1>
            <p className="text-sm text-foreground-400 font-mono mb-4">{location.pathname}</p>
            <p className="text-base text-foreground-500 mb-8">这个瓜还没长出来，换个地方看看吧</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-950 font-semibold rounded-full text-sm hover:bg-accent-600 transition-colors"
            >
              <i className="ri-arrow-left-line"></i> 返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}